<div *ngFor="let section of sections$ | async" (click)="selectSection(section)" class="item mat-elevation-z4">
    <div class="name">{{section.name}}</div>
    <mat-icon (click)="selectSection(section)">keyboard_arrow_right</mat-icon>
</div>
